import { Card, Space } from "antd";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import LeftArrowIcon from "../../../assets/icons/LeftArrowIcon";
import BatchPaymentDetailsTable from "../../../components/NP/Payment/BatchPaymentDetailsTable";
import IconButton from "../../../components/common/IconButton";
import Subheader from "../../../components/ui/Subheader";
import useModal from "../../../hooks/useModal";
import AdminLayout from "../../../layouts/AdminLayout";
import { getSinglePOForVendorAsync } from "../../../store/features/NP/supplier/supplierAPI";
import { useAppDispatch, useAppSelector } from "../../../store/store";
import { CreditCardItem } from "../../../types/redux/NP/supplier";
import { formatSouthAsianNumber } from "../../../utils/number";

export default function BatchPaymentDetails() {
  const { login } = useAppSelector((state) => state.login);

  const navigate = useNavigate();
  const {
    open: rejectOpen,
    toggle: rejectToggle,
    handleOpen: handleRejectOpen,
  } = useModal();
  const {
    open: financePaymentOpen,
    toggle: financePaymentToggle,
    handleOpen: handleFinancePaymentOpen,
  } = useModal();

  const {
    open: verifyOpen,
    toggle: verifyToggle,
    handleOpen: handleVerifyOpen,
  } = useModal();

  const {
    open: approveOpen,
    toggle: approveToggle,
    handleOpen: handleApproveOpen,
  } = useModal();
  const { getSinglePOForVendor } = useAppSelector((state) => state.supplier);
  const dispatch = useAppDispatch();

  const creditCards: CreditCardItem[] = [
    {
      title: "Total PO Value",
      value: `৳${formatSouthAsianNumber(getSinglePOForVendor?.totalAmount)}`,
    },
    {
      title: "Remaining PO Value",
      value: `৳${formatSouthAsianNumber(
        getSinglePOForVendor?.remainingPoBalance
      )}`,
    },
    {
      title: "PO Value Used",
      value: `${formatSouthAsianNumber(
        getSinglePOForVendor?.usagePercentage
      )}%`,
    },
  ];

  useEffect(() => {
    if (login?.role === "vendor") {
      dispatch(getSinglePOForVendorAsync());
    }
  }, [dispatch, login?.role]);

  return (
    <>
      <AdminLayout title="Payment Summary" headerTitle="Payment">
        {login?.role === "vendor" && (
          <section className="mt-7">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
              {creditCards.map((card, index) => (
                <Card key={index}>
                  <div className="justify-start text-slate-700 text-base font-medium">
                    {card.title}
                  </div>
                  <div className="justify-start text-slate-700 text-3xl font-semibold">
                    {card.value}
                  </div>
                </Card>
              ))}
            </div>
          </section>
        )}

        <section className="mt-7">
          <Subheader title="Payment Summary" subTitle={``}>
            <Space size="middle" className="flex-wrap">
              {/* {(login?.role === "vendor" || login?.role === "region") && (
                <Button
                  type="primary"
                  onClick={() =>
                    handleVerifyOpen({
                      type: "VERIFY",
                    })
                  }
                >
                  Verify
                </Button>
              )} */}

              {/* {(login?.role === "gr" || login?.role === "region") && (
                <Button
                  type="primary"
                  onClick={() =>
                    handleVerifyOpen({
                      type: "APPROVE",
                    })
                  }
                >
                  Approve
                </Button>
              )} */}

              {/* {login?.role === "finance" && (
                <Button
                  type="primary"
                  onClick={() =>
                    handleFinancePaymentOpen({
                      type: "FINANCE_PAYMENT",
                    })
                  }
                >
                  Payment
                </Button>
              )} */}

              {/* {login?.role !== "vendor" && login?.role !== "region" && (
                <Button
                  onClick={() =>
                    handleRejectOpen({
                      type: "REJECT",
                    })
                  }
                  className="px-3.5 py-2 bg-red-500 text-white text-sm font-medium inline-flex items-center !border-none 
    hover:!bg-red-600 hover:!text-white hover:!border-none focus:!outline-none"
                >
                  Reject
                </Button>
              )} */}

              <IconButton
                className="!border-others-header !text-sm !font-normal !rounded-lg !border !text-header !bg-transparent"
                type="default"
                icon={<LeftArrowIcon />}
                onClick={() => navigate(-1)}
              >
                <span>Back</span>
              </IconButton>
            </Space>
          </Subheader>

          <BatchPaymentDetailsTable
            verifyOpen={verifyOpen}
            verifyToggle={verifyToggle}
            rejectOpen={rejectOpen}
            rejectToggle={rejectToggle}
            financePaymentOpen={financePaymentOpen}
            financePaymentToggle={financePaymentToggle}
            approveOpen={approveOpen}
            approveToggle={approveToggle}
          />
        </section>
      </AdminLayout>
    </>
  );
}
